// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 493 ? "bf5f3635" : chunkId) + "." + {"139":"ebb081c5fd0326ae","493":"ce9dd6ff31cf9ab5","646":"120e26959f6d7237","704":"58d334a6e40d0b12"}[chunkId] + ".js";
};